function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "12",
  height: "12",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h12v12H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.47 11.5l-.012-.002a.502.502 0 01-.08-.013l-.022-.006a.446.446 0 01-.166-.087.504.504 0 01-.043-.038l-.022-.023a.506.506 0 01-.027-.033l.049.056a.502.502 0 01-.147-.36l.001-.022.003-.036.004-.025.828-4.566a.5.5 0 01.992.089l-.008.09-.541 2.991 8-8a.5.5 0 01.764.638l-.058.07L2.91 10.3l3.088-.43a.5.5 0 01.544.339l.02.088a.5.5 0 01-.338.544l-.088.02-4.566.634-.012.002a.503.503 0 01-.056.003l.068-.005a.507.507 0 01-.1.004z",
  fill: "#E9434A"
}))));